"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendThemeChangedPostMessage = exports.postMessageType = void 0;
var postMessageType = "themeChange";
exports.postMessageType = postMessageType;
var sendThemeChangedPostMessage = function sendThemeChangedPostMessage(windowForPostMessage, theme, domain) {
  if (typeof windowForPostMessage.postMessage === "undefined") return;
  windowForPostMessage.postMessage({
    type: postMessageType,
    value: theme
  }, domain || "*");
};
exports.sendThemeChangedPostMessage = sendThemeChangedPostMessage;